/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneCustomOptions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaSelectOneAddCustomAction from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneAddCustomAction/index'
import TysiaSelectOneOption from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneCustomOptions({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneCustomOptions",
  isShowingAddFilterAsCustomOption,
  onClickAddFilterAsCustomOption,
  valueFilter,
  fromCustom,
  isMultiChoice,
  isSelected,
  onClick,
  size,
  disabled
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={isShowingAddFilterAsCustomOption}>
<TysiaSelectOneAddCustomAction
  viewPath={`${viewPath}/TysiaSelectOneAddCustomAction`}
 onClick={onClickAddFilterAsCustomOption}
 text={valueFilter}
/>
</fromFlow.When>
<div
  data-testid="TysiaSelectOneCustomOptions.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(fromCustom) && fromCustom.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tysia_select_one_option"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TysiaSelectOneOption(${item?.id ?? item?._id ?? index})`}
      >
<TysiaSelectOneOption
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TysiaSelectOneOption(${item?.id ?? item?._id ?? index})`}
 isMultiChoice={isMultiChoice}
 field="text"
 isSelected={isSelected}
 onClick={onClick}
 size={size}
 disabled={disabled}
 custom={true}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }